import { render } from "./App.vue?vue&type=template&id=31e24180"
const script = {}

import "./App.vue?vue&type=style&index=0&id=31e24180&lang=scss"

import exportComponent from "D:\\doc\\project\\kepukeyanchengguozhanshi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__